import BaseInfoPanelMediator from "./BaseInfoPanelMediator";

export default class StoryInfoPanelMediator extends BaseInfoPanelMediator {
    constructor(target, dispatcher, languagePack, layoutManager, soundManager) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
    }

    initialize() {
        super.initialize();
        this.applyText(this._panel.titleTextfield, this.getText("storyInfo.title"));
        this.applyText(this._panel.closeInstructionsTextfield, this.getText("storyInfo.closeInstructions"));
    }

    setStoryInfo(text) {
        this.applyText(this._panel.bodyTextfield, text);
    }

    show(instant = false, showNudge = false) {
        this._target.visible = true;
        const targetY = this._closeY;
        if (instant) {
            this._panel.y = targetY;
        } else {
            createjs.Tween.get(this._panel)
                .to({ y: targetY }, 500, createjs.Ease.backOut)
                .call(() => {
                    if(showNudge) {
                        this._nudgeOnce(2);
                    }
                });
        }
    }

    hide(instant = false) {
        const targetY = this._closeY - 300;
        if (instant) {
            this._panel.y = targetY;
            this._target.visible = false;
        } else {
            createjs.Tween.get(this._panel)
                .to({ y: targetY }, 500, createjs.Ease.sineOut)
                .call(() => this._target.visible = false);
        }
    }
}